/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';

/*
 * A utility to find the parent of the given item.
 *
 * @param {object} item
 * @param {array} items
 * @return {object}
 */
var findParent = function findParent(item) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var parent;
  if (item.parentId) {
    items.some(function (theItem) {
      if (theItem.id === item.parentId) {
        parent = theItem;
        return true;
      }
      return false;
    });
  }
  return parent;
};

/**
 * A utility to build the hierarchy of the given item starting from root.
 */
var _buildHierarchy = function buildHierarchy(item) {
  var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var hierarchy = [];
  if (item.parentId) {
    var parent = findParent(item, items);
    if (parent) {
      var parentHierarchy = _buildHierarchy(parent, items);
      hierarchy.push.apply(hierarchy, _toConsumableArray(parentHierarchy));
    }
  }
  hierarchy.push(item);
  return hierarchy;
};
var defaultCompareItems = function defaultCompareItems(itemA, itemB, _ref) {
  var locale = _ref.locale;
  return itemA.localeCompare(itemB, locale, {
    numeric: true
  });
};

/**
 * Default sorting algorithm for options in a selection control
 */
var defaultSortItems = function defaultSortItems(items, _ref2) {
  var itemToString = _ref2.itemToString,
    compareItems = _ref2.compareItems,
    _ref2$locale = _ref2.locale,
    locale = _ref2$locale === void 0 ? 'en' : _ref2$locale;
  var itemArr = _toConsumableArray(items);
  return items.sort(function (itemA, itemB) {
    var hierarchyA = _buildHierarchy(itemA, itemArr);
    var hierarchyB = _buildHierarchy(itemB, itemArr);
    var depth = hierarchyA.length > hierarchyB.length ? hierarchyA.length : hierarchyB.length;
    var compareResult = 0;
    for (var i = 0; i < depth; i += 1) {
      var currentA = hierarchyA[i];
      var currentB = hierarchyB[i];
      if (currentA && !currentB) {
        // `currentA` is a child of `currentB`
        // always place the child after the parent
        return 1;
      }
      if (!currentA && currentB) {
        // `currentB` is a child of `currentA`
        // always place the child after the parent
        return -1;
      }
      compareResult = compareItems(itemToString(currentA), itemToString(currentB), {
        locale: locale
      });
      if (compareResult !== 0) {
        return compareResult;
      }
    }
    return compareResult;
  });
};

export { _buildHierarchy as buildHierarchy, defaultCompareItems, defaultSortItems, findParent };
